import { ThumbnailTextListCombinedProps } from './types';

const usePresenter = (props: ThumbnailTextListCombinedProps): ThumbnailTextListCombinedProps => {
  return props;
};

export default usePresenter;
